<div class="cc-sign-in-out-wrapper d-flex">
  <div class="cc-sign-in-out-status">{{ UserName }} {{ StatusString }}</div>
  <!--Sign In/Out-->
  <div class="cc-sign-out" [ngClass]="{ 'signed-in': IsSignedIn }">
    <input
      maxlength="250"
      app-filter
      pattern="^[^><&]*$"
      [(ngModel)]="SignoutReason"
      *ngIf="IsSignedIn"
      type="text"
    />
    <button
      title="{{ IsSignedIn ? SignOutLobby : SignInLobby }}"
      id="btn-sign-in-out-action"
      type="button"
      (click)="OnActionClicked()"
      class="cc-sign-in-out-btn"
    >
      <span
        class="fas"
        [ngClass]="{
          'fa-sign-in-alt': !IsSignedIn,
          'fa-sign-out-alt': IsSignedIn,
        }"
      ></span>
    </button>
  </div>
</div>

<app-sign-in-modal-popup
  [(dialogOpened)]="ShowSignInPopup"
  header="{{ '_Shared_App_SignIn_PopUp_Text_' | translate }}"
  message="{{ '_Shared_App_SignIn_Message_Text_' | translate }}"
  actionYesLabel="{{ '_Shared_App_SignIn_Yes_Action_Text_' | translate }}"
  actionNoLabel="{{ '_General_Button_Cancel_Text_' | translate }}"
  (submitted)="SignInPopupYesClicked()"
  (cancelled)="SignInPopupNoClicked()"
>
</app-sign-in-modal-popup>

<kendo-dialog
  title="{{ '_Shared_App_SignIn_Unable_SignIn_Title_Text_' | translate }}"
  *ngIf="ShowUnableToSignInPopup"
  (close)="CloseUnableToSignInPrompt()"
  [minWidth]="300"
  [width]="600"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <p>{{ "_Shared_App_SignIn_Unable_SignIn_Info_Text_" | translate }}</p>

  <kendo-dialog-actions class="cc-btn-panel">
    <button
      class="btn btn-primary"
      primary="true"
      (click)="CloseUnableToSignInPrompt()"
    >
      {{ "_General_Button_Ok_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  title="{{ '_Shared_App_SignIn_Unable_CheckIn_Title_Text_' | translate }}"
  *ngIf="ShowUnableToCheckInPopup"
  (close)="CloseUnableToCheckInPrompt()"
  [minWidth]="300"
  [width]="600"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <p>{{ "_Shared_App_SignIn_Unable_CheckIn_Info_Text_" | translate }}</p>

  <kendo-dialog-actions class="cc-btn-panel">
    <button
      class="btn btn-primary"
      primary="true"
      (click)="CloseUnableToCheckInPrompt()"
    >
      {{ "_General_Button_Ok_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  title="{{ '_Shared_Signed_Into_Ts_Text_' | translate }} {{ locationName }}"
  *ngIf="showImpersonateInfo"
  (close)="CloseImpersonateInfo()"
  [minWidth]="300"
  [width]="600"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>
  <p>
    {{ "_Shared_Layout_Signin_Automatically_Text_" | translate }}
    {{ locationName }}
    {{ "_Shared_Layout_Signin_Automatically_Impersonate_Text_" | translate }}
    {{ impersonateByName
    }}{{ "_Shared_Layout_Signin_Not _Change_Location_Text_" | translate }}
  </p>

  <kendo-dialog-actions class="cc-btn-panel">
    <button
      class="btn btn-primary"
      primary="true"
      (click)="CloseImpersonateInfo()"
    >
      {{ "_General_Button_Ok_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  title="{{ '_JIT_User_Account_Update_Text_' | translate }}"
  *ngIf="showUserAccountUpdatedPopup"
  (close)="CloseUserAccountUpdatedPopup()"
  [minWidth]="300"
  [width]="750"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>

  <p>
    {{ "_JIT_User_Account_Update_Sub_Text_" | translate }}
  </p>

  <kendo-grid [data]="userAccountUpdateRows">
    <kendo-grid-column
      field="field"
      title="{{ '_General_User_Field_Text_' | translate }}"
      [width]="250"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.fieldKey | translate }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="value"
      title="{{ '_General_Value_Text_' | translate }}"
      [width]="400"
    >
    </kendo-grid-column>
  </kendo-grid>

  <kendo-dialog-actions class="cc-btn-panel">
    <button
      class="btn btn-primary"
      primary="true"
      (click)="CloseUserAccountUpdatedPopup()"
    >
      {{ "_General_Button_Ok_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
